import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-not-online',
  templateUrl: './store-not-online.component.html',
  styleUrls: ['./store-not-online.component.css']
})
export class StoreNotOnlineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
